import React from 'react';
import styled from 'styled-components';
import * as styles from './styles';
import { InvoiceInfoProps } from './models';
import { useTranslation } from '@sunbit-dev/translations';
import { formatCurrency } from '@sunbit-dev/common/helpers/money';
import { useSelector } from 'react-redux';
import { getStore } from '~/store/reducers/purchase/purchase';

export const InvoiceInfo = styled(({ className }: InvoiceInfoProps) => {
  const { t } = useTranslation('landing_page', { keyPrefix: 'welcome_view' });
  const { purchaseInfo } = useSelector(getStore);

  if (!purchaseInfo.amountRequested || !purchaseInfo.roNumber) {
    return null;
  }

  const formattedAmount = formatCurrency({
    value: purchaseInfo.amountRequested.toString(),
    showFullDecimalNumber: true,
  });

  return (
    <div className={className}>
      <span>{t('invoice.amount', { amount: formattedAmount })}</span>
      <span>{t('invoice.ro', { roNumber: purchaseInfo.roNumber })}</span>
      <span className="down-payment-notice">{t('down_payment_notice')}</span>
    </div>
  );
})`
  ${styles.InvoiceInfo}
`;
